/**
 * パンくずナビに aria-label を設定し、
 * 表示中のページと同じ URL のリンクに aria-current を追加
 * https://www.w3.org/TR/wai-aria-practices/examples/breadcrumb/
 */
const replaceCond = /index\.html$/; // 置換条件

const targetId = 'breadcrumb'; // パンくずナビの id 属性値を指定

const target = document.getElementById(targetId);
const path = window.location.pathname.replace(replaceCond, '');
window.addEventListener('load', () => {
  // パンくずナビが存在しなければ停止
  if (!target) return; // パンくずナビに aria-label を設定

  target.setAttribute('aria-label', 'Breadcrumb'); // パンくずナビの子要素のリンクを収集

  const hrefs = target.querySelectorAll('a'); // 現在地のリンクに aria-current を設定
  // 注：NodeList の forEach は IE 非対応

  hrefs.forEach(node => {
    const href = node.getAttribute('href').replace(replaceCond, '');

    if (href === path) {
      node.setAttribute('aria-current', 'page');
      node.setAttribute('tabindex', '-1');
    }
  });
});